/* eslint-disable no-template-curly-in-string */
import { country } from '../../../utils/current-site';

export const MAX_DISTANCE = 50;
export const statuses = {
  ZERO_RESULTS: 'No results found',
  OUT_OF_BOUNDS: 'Out of bounds',
  NOT_IN_COUNTRY: `Search location not in ${country}`,
  OK: 'OK',
};

export const ENDPOINT = '/api/shelter-locations';
